module.exports = __webpack_public_path__ + "static/media/unilimerick.b63b0a8b.png";